import { UserModel } from '@/features/auth/types';

class StorageService {
  private readonly PREFIX = 'eduquanto';

  getToken(): string | null {
    return window.localStorage.getItem(`${this.PREFIX}_token`);
  }

  setToken(token: string): void {
    window.localStorage.setItem(`${this.PREFIX}_token`, token);
  }

  removeToken(): void {
    window.localStorage.removeItem(`${this.PREFIX}_token`);
  }

  getRefreshToken(): string | null {
    return window.localStorage.getItem(`${this.PREFIX}_refresh_token`);
  }

  setRefreshToken(refreshToken: string): void {
    window.localStorage.setItem(`${this.PREFIX}_refresh_token`, refreshToken);
  }

  removeRefreshToken(): void {
    window.localStorage.removeItem(`${this.PREFIX}_refresh_token`);
  }

  getUser(): UserModel | null {
    return JSON.parse(window.localStorage.getItem(`${this.PREFIX}_user`));
  }

  setUser(user: UserModel): void {
    window.localStorage.setItem(`${this.PREFIX}_user`, JSON.stringify(user));
  }

  removeUser(): void {
    window.localStorage.removeItem(`${this.PREFIX}_user`);
  }

  clearAll(): void {
    window.localStorage.clear()
  }
}

const storage = new StorageService();

export { storage };
